import { createAPIMethod } from 'utils/generic';
import {
	normalizeCategoryData,
	type CategoryData,
	type CategorySuggests,
	type ResponseCategoryData,
} from 'service/category/model';

export type SortBy = 'name' | '-adverts_count' | 'adverts_count';

export type GetCachedCategoriesParams = { sort: SortBy; limit: string; category_id?: string };

export async function getCategoriesCached(params: GetCachedCategoriesParams) {
	try {
		return await createAPIMethod<GetCachedCategoriesParams, CategoryData[]>({
			path: `/categories/cached`,
			method: 'GET',
			useCache: true,
			normalize: ({ results }) =>
				results?.map((category: ResponseCategoryData) => normalizeCategoryData(category)),
		})(params);
	} catch (error) {
		console.error('getCategoriesCached error', error);
		return [];
	}
}

export type SearchCategoriesParams = {
	category_id?: string;
	hide_price_by_agreement?: 'true' | 'false';
	limit?: string;
	locality?: string;
	offset?: string;
	phrase?: string;
	premise_id?: string;
	price_for_free?: 'true' | 'false';
	price_from?: string;
	price_to?: string;
	radius_precision?: string;
	sort?: SortBy;
	timestamp_to?: string;
	user_id?: string;
};

export async function searchCategories(
	params: SearchCategoriesParams,
	headers?: HeadersInit,
	abortController?: AbortController,
) {
	try {
		return await createAPIMethod<SearchCategoriesParams, CategoryData[]>({
			path: `/categories/search`,
			method: 'GET',
			normalize: ({ results }) =>
				results?.map((category: ResponseCategoryData) => normalizeCategoryData(category)),
			headers,
			useCache: true,
			abortController,
		})(params);
	} catch (error) {
		console.error('searchCategories error', error);
		return [];
	}
}

type SuggestCategoriesParams = { name: string };

export async function suggestCategories(params: SuggestCategoriesParams, headers?: HeadersInit) {
	try {
		return await createAPIMethod<object, CategorySuggests[]>({
			path: `/categories/suggest`,
			method: 'POST',
			headers,
		})(params);
	} catch (error) {
		console.error('suggestCategories error', error);
		return [];
	}
}

export type SearchUserCategoriesParams = {
	advert_locality?: string;
	advert_price_for_free?: 'true' | 'false';
	advert_price_from?: string;
	advert_price_to?: string;
	advert_status?: string;
	advert_valid_date_from?: string;
	advert_valid_date_to?: string;
	limit?: string;
	offset?: string;
	radius_precision?: string;
	sort?: SortBy;
};

export async function userCategories(params: SearchUserCategoriesParams, headers?: HeadersInit) {
	try {
		return await createAPIMethod<SearchCategoriesParams, CategoryData[]>({
			path: `/categories/user`,
			method: 'GET',
			normalize: ({ results }) =>
				results?.map((category: ResponseCategoryData) => normalizeCategoryData(category)),
			headers,
			useCache: false,
		})(params);
	} catch (error) {
		console.error('userCategories error', error);
		return [];
	}
}
